import { AxiosResponse } from 'axios';
import axiosInstanceBFF from 'services/AxiosInstanceBFF';

export type LookerProps = {
  type: string;
  embedURL: string;
  userTimezone: string;
  userFirstName: string;
  userLastName: string;
  userLocale: string;
  customerName: string;
  yaloBotId: string;
  email: string;
};

interface IGetAnalytics {
  success: string;
  url: string;
}

export const getAnalytics = async (props: LookerProps): Promise<AxiosResponse<IGetAnalytics>> => {
  const { userFirstName, userLastName, customerName, yaloBotId, userTimezone, type, embedURL, userLocale, email } =
    props;

  return axiosInstanceBFF.post('v1/looker/create-embed-url', {
    externalUserId: `${email}_${yaloBotId}`,
    permissions: [
      'access_data',
      'see_lookml_dashboards',
      'see_looks',
      'see_user_dashboards',
      'download_without_limit',
      'see_drill_overlay',
    ],
    models: ['dwh_salesdesk'],
    accessFilters: {},
    firstName: userFirstName,
    lastName: userLastName,
    userAttributes: {
      email,
      yalo_account_id: customerName,
      yalo_bots_id: yaloBotId,
      yalo_enviroment: 'global',
      locale: userLocale,
    },
    userTimezone,
    sessionLength: 6000,
    embedUrl: `/embed/dashboards/dwh_salesdesk::${type}?embed_domain=${embedURL}`,
    forceLogoutLogin: true,
  });
};
